<img alt="Background" class="background" src="/assets/icons/dashboard/background.svg"/>
<main>
  @defer (when dashboardData() !== undefined) {
    @let data = dashboardData()!;
    <app-header [userName]="userName()"/>
    <div class="dashboard-container">
      <!-- Apps Grid -->
      <div class="apps-grid">
        @for (app of data.applications; track $index) {
          <app-application-card [application]="app"
                                [attachedLinks]="data | applicationLink : app.slug"></app-application-card>
        }
      </div>
      <div class="unattached-links">
        @for (link of unAttachedLinks(); track $index) {
          <app-link-card [link]="link"></app-link-card>
        }
      </div>
    </div>
    <app-footer [dashboardData]="data"/>
  } @placeholder {
    <div class="loading-state">
      <div class="spinner"></div>
      Chargement des applications...
    </div>
  }
</main>
